import React from 'react';

export const Anchor: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({ children, ...rest }) => (
  <a className="text-navy-blue hover:underline hover:cursor-pointer" {...rest}>
    {children}
  </a>
);
